<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <br />
    <div class="detallePostal">
      <b-form-group
        label="Tipo de Postal:"
        label-align="left"
        class="mginInputTrt"
        id="fieldset-1"
      >
        <b-form-select v-model="postal.tipo" :options="tipos"></b-form-select>
      </b-form-group>

      <b-form-group
        label="Área Corporativa	:"
        label-align="left"
        class="mginInputTrt"
        id="fieldset-2"
      >
        <b-form-select v-model="postal.areaId" :options="areas"></b-form-select>
      </b-form-group>

      <b-form-group
        label="Link:"
        label-align="left"
        class="mginInputTrt"
        id="fieldset-3"
      >
        <b-form-input v-model="postal.link" type="url"></b-form-input>
      </b-form-group>

      <b-form-group
        label="Postal:"
        label-align="left"
        class="mginInputTrt"
        id="fieldset-4"
      >
        <img alt="img" :src="image" class="imagenDinamica" v-if="file == null" />

        <b-form-file
          class="mt-3"
          plain
          accept=".jpg, .png, .gif, .jpeg"
          @change="selectFile"
        ></b-form-file>
      </b-form-group>

      <b-button
        variant="primary"
        :disabled="
          postal.tipo == null ||
          postal.areaId == null ||
          postal.link == null ||
          btnDisabled == true
        "
        @click="actualizarPostal"
        >Guardar</b-button
      >
      <br />
      <br />
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import miniToastr from "mini-toastr"; //ES6
export default {
  name: "Postal",
  props: {
    msg: String,
  },
  components: { Header },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    btnDisabled: false,
    postal: {
      tipo: null,
      areaId: null,
      link: null,
    },
    tipos: [
      { value: null, text: "Selecciona una opción", disabled: true },
      { value: 1, text: "Anuncio" },
      { value: 2, text: "Cumpleaños" },
    ],
    areas: [],
    file: null,
    id: null,
    image: null,
    tamanos: {
      width: null,
      height: null,
    },
  }),

  methods: {
    selectFile(e) {
      let files = e.target.files || e.dataTransfer.files;

      const file = new Blob([files[0]], { type: "image/png" });

      this.file = file;

      let reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = (evt) => {
        let img = new Image();
        img.onload = () => {
          if (img.width > 850 || img.height > 350) {
            this.file = null;

            this.$swal({
              icon: "error",
              title: "La imagen excede del tamaño 850px x 350px",
              showConfirmButton: false,
              timer: 2500,
            });
          }
        };
        img.src = evt.target.result;
      };

      reader.onerror = (evt) => {
        console.error(evt);
      };
    },
    actualizarPostal() {
      if (this.file != null) {
        let config = {
          header: {
            "Content-Type": "image/png",
          },
        };
        const formData = new FormData();
        formData.append("imagen", this.file, this.file.filename);
        this.$swal
          .fire({
            title: "¿Estás seguro de actualizar la postal?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
            preConfirm: () => {

              this.btnDisabled = true;
              this.$http
                .post(
                  this.$api +
                    "postal/actualizar?tipo=" +
                    this.postal.tipo +
                    "&idPostal=" +
                    this.id +
                    "&registroActivo=" +
                    this.postal.registroActivo +
                    "&areaId=" +
                    this.postal.areaId +
                    "&link=" +
                    this.postal.link +
                    "&idUsuario=" +
                    this.$localStorageService.getIdUsuario(),
                  formData,
                  config
                )
                .then((response) => {
                  if (response.status === 200) {
                    var message = response.data.message
                      ? response.data.message
                      : "Se guardo correctamente el registro";
                    miniToastr.success(message);
                  }
                })
                .catch((error) => {
                  var message = error.response.data.message
                    ? error.response.data.message
                    : "Error al crear el registro";
                  miniToastr.info(message);
                  this.btnDisabled = false;
                })
                .finally(() => {
                  this.btnDisabled = false;
                  this.$router.push({
                    name: "postales",
                  });
                });
              //   pendiente
            },
            allowOutsideClick: () => !this.$swal.isLoading(),
          })
          .then((result) => {
            if (result.value) {
              this.$swal({
                icon: "success",
                title: "Se registro correctamente",
                showConfirmButton: false,
                timer: 2500,
              });
            }
          });
      } else {
        this.$swal
          .fire({
            title: "¿Estás seguro de actualizar la postal?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
            preConfirm: () => {

              this.btnDisabled = true;
              const params = {
                tipo: this.postal.tipo,
                idPostal: this.id,
                registroActivo: this.postal.registroActivo,
                areaId: this.postal.areaId,
                link: this.postal.link,
                idUsuario: this.$localStorageService.getIdUsuario()
              }
              this.$http
                .post(
                  this.$api +
                    "postal/actualizarSinFoto",
                    params
                )
                .then((response) => {
                  if (response.status === 200) {
                    var message = response.data.message
                      ? response.data.message
                      : "Se guardo correctamente el registro";
                    miniToastr.success(message);
                  }
                })
                .catch((error) => {
                  var message = error.response.data.message
                    ? error.response.data.message
                    : "Error al crear el registro";
                  miniToastr.info(message);
                  this.btnDisabled = false;
                })
                .finally(() => {
                  this.btnDisabled = false;
                });
              //   pendiente
            },
            allowOutsideClick: () => !this.$swal.isLoading(),
          })
          .then((result) => {
            if (result.value) {
              this.$swal({
                icon: "success",
                title: "Se registro correctamente",
                showConfirmButton: false,
                timer: 2500,
              });
            }

            setTimeout(
              () =>
                this.$router.push({
                  name: "postales",
                }),
              4000
            );
          });
      }
    },
    obtenerAreas() {
      this.$http
        .get(this.$api + "catalogos/listaAreas")
        .then((response) => {
          if (response.status === 200) {
            this.areas = response.data.data.map(function (itm) {
              itm.value = itm.idArea;
              itm.text = itm.nombreArea;
              return itm;
            });

            this.areas.push({
              value: null,
              text: "Selecciona una opción",
              disabled: true,
            });

          }
        })
        .catch((error) => {
          console.error(error);
        });
    },

    obtenerPostal() {
      this.$http
        .post(this.$api + "postal/", this.id)
        .then((response) => {
          if (response.status === 200) {
            this.postal = Object.assign({}, response.data.data);

            this.image = "data:image/png;base64," + this.postal.dataFile;

          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.obtenerAreas();
    this.obtenerPostal();
    this.debug = this.$localStorageService.getDebug();
  },
};
</script>

<style scoped>
.mginInputTrt {
  padding: 10px;
  font-weight: bolder !important;
}

.txtLeft {
  font-weight: bolder;
  text-align: left;
  margin-left: 10px;
}

.paddingDiv {
  padding: 10px;
}

.imagenDinamica {
  width: 350px;
  max-width: 350px;
  height: 150px;
  max-height: 150px;
}

.detallePostal {
  padding: 30px;
}
</style>
